import { Component } from "@angular/core";
import { InternationalService } from "./international.service";
import { TranslateService, Lang } from "@root/shared/service/translate.service";
import _ from "lodash";
import { Title, Meta } from "@angular/platform-browser";
import { AppService } from "./app.service";
@Component({
  selector: "host-root",
  template: "<router-outlet></router-outlet>",
})
export class AppPublicComponent {
  get isInternational() {
    return this.app.app.international;
  }

  constructor(
    private internationalService: InternationalService,
    private title: Title,
    private meta: Meta,
    private app: AppService,
  ) {
    console.log("init h5 modules ... ");
    console.log("%cInternational Init", "font-weight: 900");
    this.printEasterEgg();
    this.initI18nInfo();

    // this.initLanguage();
    // this.initDownloadInfo();

    this.hideMainLoading();
  }

  private hideMainLoading() {
    const loading = document.getElementById("layout-main-loading");
    if (loading) {
      loading.style.display = "none";
    }
  }

  private printEasterEgg() {
    console.log(
      "%cHostex Mobile%c打造中国最好的民宿管理系统",
      "background: linear-gradient(to right, hsl(60, 40%, 60%), #2c80f0); padding: 5px 10px; color:#fff;font-size:20px;font-weight:900;letter-spacing:20px;",
      "color: #fff;padding: 5px;background: hsl(180, 40%, 60%);font-size:20px;font-weight:900",
    );
  }

  private initI18nInfo() {
    // 通用设置
    // 如果用户未登录，则该接口将不返回数据，语言由本地判断
    // this.initInternationalSetting();
    // 本地语言判断，用于用户未登录时，设置默认语言
    this.initLanguageInfo();
    // html meta info
    this.initMetaInfo();
  }

  private initLanguageInfo() {
    if (this.isInternational) {
      console.log("is internation");

      this.internationalService.setLanguage(Lang.EN);
      // const storeLang = this.translateService.getStoreLang();
      // if (storeLang !== null) {
      //   this.internationalService.setLanguage(storeLang);
      // } else {
      //   this.internationalService.setLanguage(Lang.EN);
      // }
    } else {
      console.log("is not internation");

      this.internationalService.setLanguage(Lang.ZH);
    }
  }

  private initMetaInfo() {
    if (this.isInternational) {
      this.updateMetaInfo(Lang.EN);
    } else {
      this.updateMetaInfo(Lang.ZH);
    }
  }

  private updateMetaInfo(lang: Lang) {
    const cnHead = {
      title: "百居易Hostex - 民宿管理系统 - 轻松管理大量民宿房源",
      description:
        "官方直连爱彼迎、美团民宿、途家、携程等多平台，房态、房价、房客消息一站式管理，自动关房和回复咨询，不同业务规模均可高效运营。支持Web和独立App。",
      keywords: "短租民宿,酒店客栈pms,管理系统,宝寓,订单来了,云掌柜,民宿宝,去呼呼,番茄来了",
    };
    const enHead = {
      title: "Hostex - Airbnb short-term & vacation rental property management software",
      description:
        "Hostex is a short-term & vacation rental property management software. Integration with Airbnb, Booking, etc., one-stop management of availability, rates, guest messages and reservations. Helps you manage a large number of listings efficiently.",
      keywords:
        "bnb,vacation rental,short term rental management,property management,guesty,smartbnb,igms,syncbnb,yourporter,lodgify",
    };

    if (lang === Lang.ZH) {
      this.title.setTitle(cnHead.title);
      this.meta.updateTag({ content: cnHead.description }, 'name="description"');
      this.meta.updateTag({ content: cnHead.keywords }, 'name="keywords"');
    } else {
      this.title.setTitle(enHead.title);
      this.meta.updateTag({ content: enHead.description }, 'name="description"');
      this.meta.updateTag({ content: enHead.keywords }, 'name="keywords"');
    }
  }
}
